import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LiabilityDataModel } from '../../models/liability-data.model';
import { PaymentTypeEnum } from '../../models/payment-type.model';

@Component({
  selector: 'app-payment-type-toggle',
  templateUrl: './payment-type-toggle.component.html',
  styleUrls: ['./payment-type-toggle.component.scss']
})
export class PaymentTypeToggleComponent implements OnInit {
  PaymentTypeEnum = PaymentTypeEnum;

  @Input()
  payment: LiabilityDataModel;

  @Input()
  paymentType: PaymentTypeEnum;

  @Output()
  typeChange = new EventEmitter<PaymentTypeEnum>();

  constructor() {}

  ngOnInit(): void {}

  changeType(type: PaymentTypeEnum) {
    this.typeChange.emit(type);
  }
}
